<script setup lang="ts">
import BtnTemplate from './template.vue'

type Props = {
  bordered?: boolean
  small?: boolean
}
type Emits = {
  click: [MouseEvent]
}

withDefaults(defineProps<Props>(), {
  bordered: false,
  small: false,
})
const emit = defineEmits<Emits>()
</script>

<template>
  <BtnTemplate
    class="ghost tw-border tw-border-solid tw-border-transparent tw-bg-transparent hover:tw-border-orange-100 hover:tw-bg-orange-100 hover:tw-shadow-round"
    :class="{ 'tw-border-orange-500': bordered, small }"
    @click="emit('click', $event)"
  >
    <span class="btnText tw-text-orange-500">
      <slot />
    </span>
  </BtnTemplate>
</template>
